import {
  faCog, faStar, faTrashAlt, faUserGear,
} from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { Button, Tools } from '@domain-group/suit-theme'

import useUser, { generateUrls } from '@hooks/useUser'

import { confirmDelete } from '@functions/entity'
import EnabledPermission from '@components/EnabledPermission'
import usePriorityCampaign from '@hooks/usePriorityCampaign'

interface UserToolsProps {
  userPayload: ReturnType<typeof useUser>,
}

type DeleteFnParams = {
  deleteUser: () => void,
  redirectUrl: string,
}

const deleteFn = async (params: DeleteFnParams) => {
  const { deleteUser, redirectUrl } = params

  const response = await deleteUser()
  // @ts-expect-error TS2339
  const { success } = response

  if (success){
    window.location.hash = redirectUrl
  }

  return response
}

const UserTools = (props: UserToolsProps) => {
  const {
    userPayload: {
      agency,
      callbacks: {
        deleteAgent, deleteUser, manageNotifications, manageUserPermissions,
      },
      loading,
      isAgent,
      isOfficeAdministrator,
      isSelf,
      user,
    },
  } = props

  // @ts-expect-error TS2339
  const { usersIndexUrl } = generateUrls({}, { prefixRoute: `agencies/${agency.id}/manage` })

  const { callbacks: { manageUserPriorityCampaigns } } = usePriorityCampaign({ owner_id: user.id, owner_type: 'User' })

  const confirmDeletePayload = {
    callbacks: { deleteFn: () => deleteFn({ deleteUser, redirectUrl: usersIndexUrl }) },
    options: { shouldRedirect: true },
    strings: { entityName: 'User' },
  }

  return (
    <Tools>
      {/*
       // @ts-expect-error TS2746 */}
      <EnabledPermission permissionKey="admin.users.manage">
        {isAgent && !isSelf && (
          <Button
            buttonStyle="secondaryUtility"
            icon={<FontAwesomeIcon icon={faTrashAlt} />}
            loading={loading}
            marginBottom="medium"
            onClick={() => deleteAgent()}
            size="medium"
          >
            Remove Agent from Agency
          </Button>
        )}

        {isOfficeAdministrator && !isSelf && (
          <Button
            buttonStyle="secondaryUtility"
            icon={<FontAwesomeIcon icon={faTrashAlt} />}
            loading={loading}
            marginBottom="medium"
            // @ts-expect-error TS2345
            onClick={() => confirmDelete(confirmDeletePayload)}
            size="medium"
          >
            Remove Admin from Agency
          </Button>
        )}
      </EnabledPermission>

      <Button
        buttonStyle="secondaryUtility"
        icon={<FontAwesomeIcon icon={faCog} />}
        loading={loading}
        onClick={() => manageNotifications()}
        size="medium"
      >
        Notification Options
      </Button>

      {/*
       // @ts-expect-error TS2746 */}
      <EnabledPermission permissionKey="admin.users.manage">
        <Button
          buttonStyle="secondaryUtility"
          icon={<FontAwesomeIcon icon={faUserGear} />}
          loading={loading}
          marginTop="medium"
          onClick={() => manageUserPermissions()}
          size="medium"
        >
          User Permissions
        </Button>

        {isOfficeAdministrator && (
          <Button
            buttonStyle="secondaryUtility"
            // @ts-expect-error TS2322
            ghost
            icon={<FontAwesomeIcon icon={faStar} />}
            marginTop="medium"
            // @ts-expect-error TS2554
            onClick={() => manageUserPriorityCampaigns(user)}
            size="medium"
          >
            Manage Priority Campaigns
          </Button>
        )}
      </EnabledPermission>
    </Tools>
  )
}

export default UserTools
